import translations_fr from './fr.json'

/**
 * Use this to record additional translations
 */
export default {
    fr: translations_fr,
}